import React from "react";
import UserProfileGeneralInfoTemplate from "themes/application/user-settings/components/UserProfileGeneralInfoTemplate";

class UserProfileGeneralInfo extends React.Component {
    render() {
        return <UserProfileGeneralInfoTemplate {...this.props} />;
    }
}

export default UserProfileGeneralInfo;